import { Injector, Type } from '@angular/core';
import { ComponentType } from '@angular/cdk/portal';

export type StaticDialogCloseResult = 'confirm' | 'cancel' | 'backdrop' | 'escape';

export interface StaticDialogData {
    title: string;
    description?: string;
    content?: string;
    contentComponent?: Type<unknown>;
    cancelLabel?: string;
    confirmLabel?: string;
    closeButtonLabel?: string;
}

export interface StaticDialogConfig {
    hasBackdrop: boolean;
    closeOnBackdropClick: boolean;
    closeOnEscape: boolean;
    backdropClass: string | string[];
    panelClass: string | string[];
    width: string;
    offsetY: number;
    scrollStrategy?: 'reposition' | 'close' | 'block' | 'noop';
}

export type StaticDialogOpenConfig = Partial<StaticDialogConfig>;

export type StaticDrawerInputs<TComponent extends object = object> = Partial<
    Record<Extract<keyof TComponent, string>, unknown>
>;

export interface StaticDrawerConfig<TInputs extends object = object> {
    hasBackdrop: boolean;
    closeOnBackdropClick: boolean;
    closeOnEscape: boolean;
    backdropClass: string | string[];
    panelClass: string | string[];
    width: string;
    height: string;
    injector?: Injector;
    inputs?: StaticDrawerInputs<TInputs>;
    outputs?: StaticDrawerOutputs<TInputs>;
}

export type StaticDrawerOutputs<TComponent extends object = object> = Partial<
    Record<Extract<keyof TComponent, string>, (value: unknown) => void>
>;

export interface StaticDrawerOpenConfig<TComponent extends object = object>
    extends Partial<StaticDrawerConfig<TComponent>> {
    component: ComponentType<TComponent>;
}

export const DEFAULT_STATIC_DIALOG_CONFIG: StaticDialogConfig = {
    hasBackdrop: true,
    closeOnBackdropClick: true,
    closeOnEscape: true,
    backdropClass: 'cdk-overlay-dark-backdrop',
    panelClass: 'static-dialog-panel',
    width: 'min(32rem, calc(100vw - 2rem))',
    offsetY: 16,
};

export const DEFAULT_STATIC_DRAWER_CONFIG: StaticDrawerConfig = {
    hasBackdrop: true,
    closeOnBackdropClick: false,
    closeOnEscape: false,
    backdropClass: 'cdk-overlay-dark-backdrop',
    panelClass: 'static-dialog-drawer-panel',
    width: '100vw',
    height: '100dvh',
};